import { Container, Step, StepLabel, Stepper } from '@mui/material';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import React, { useState } from 'react';
import Step1 from './step1';
import Step2 from './step2';
import Step3 from './step3';
import CategoryStep from './categoryStep';
import { useDispatch, useSelector } from 'react-redux';
import ReferralStep from "./ReferralStep"
import { prevStep,nextStep } from "Features/jobForms/jobFormSlice";
import axios from 'axios';

const MultiForm = () => {
  const dispatch = useDispatch()
  const sessionId = useSelector((state) => state.session.sessionId);
  console.log(sessionId);
  
  const jobForm = useSelector((state) => state.form); // Access the entire form state from Redux
  const step = jobForm.step || 1;
  // const step = useSelector((state) => state.form.step || 1);
  console.log(jobForm);
  const handleNextStep = () => {
    dispatch(nextStep());
  };

  const handlePrevStep = () => {
    dispatch(prevStep());
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
 
  const apiUrl = "https://seltentechnologiesdemo.com/moona-backend/service/v4_1/rest.php";
  const method = "set_entry";
  const input_type = "JSON";
  const response_type = "JSON";

  const rest_data = JSON.stringify({
    session: sessionId,
    module_name: "APP_Job_Application",
    name_value_list: [
      { name: "category_c", value: jobForm.category.category },
      { name: "firstname_c", value: jobForm.personalInfo.firstName },
      { name: "lastname_c", value: jobForm.personalInfo.lastName },
      { name: "email_c", value: jobForm.personalInfo.email },
      { name: "dob_c", value: jobForm.personalInfo.dob },
      { name: "phone_number_c", value: jobForm.personalInfo.phoneNumber },
      { name: "alternativenumber_c", value: jobForm.personalInfo.alternativeNumber },
      { name: "gender_c", value: jobForm.personalInfo.gender },
      { name: "nationality_c", value: jobForm.personalInfo.nationality },
      { name: "disability_c", value: jobForm.personalInfo.disability },
      { name: "street_c", value: jobForm.personalInfo.street },
      { name: "city_c", value: jobForm.personalInfo.city },
      { name: "country_c", value: jobForm.personalInfo.country },
      { name: "zipcode_c", value: jobForm.personalInfo.zipcode },
      { name: "aadhar_c", value: jobForm.personalInfo.aadharCard },
      { name: "passport_c", value: jobForm.personalInfo.passport },
      { name: "pancard_c", value: jobForm.personalInfo.panCard },
      { name: "languaguagesknown_c", value: jobForm.personalInfo.LanguageKnown },
  
      // /// form 2
      { name: "qualification_c", value: jobForm.educationDetails.qualification },        
      { name: "sslc_c", value: jobForm.educationDetails.sslc },
      { name: "hsc_c", value: jobForm.educationDetails.hsc },
      { name: "diploma_c", value: jobForm.educationDetails.diploma },
      { name: "bachelordegree_c", value: jobForm.educationDetails.bachelorDegree },
      { name: "masterdegree_c", value: jobForm.educationDetails.masterDegree },
      { name: "other_c", value: jobForm.educationDetails.other },
      { name: "university_c", value: jobForm.educationDetails.university },
      { name: "graduationyear_c", value: jobForm.educationDetails.graduationYear },
      { name: "courseCompletion", value: jobForm.educationDetails.courseCompletion },
  
      // /// form 3
      // { name: "experience_c", value: jobForm.experienceDetails.experience },
      { name: "yearofexperience_c", value: jobForm.experienceDetails.yearsOfExperience },
      { name: "position_c", value: jobForm.experienceDetails.currentPosition },
      { name: "salary_c", value: jobForm.experienceDetails.currentCTC },
      { name: "country_c", value: jobForm.experienceDetails.country },
      { name: "workpermit_c", value: jobForm.experienceDetails.workPermitNumber },
      { name: "workpermitfile_c", value: jobForm.experienceDetails.workPermitNumber },
      { name: "coverletter_c", value: jobForm.experienceDetails.coverLetter },
      { name: "resume_c", value: jobForm.experienceDetails.resume },
      // { name: "skills_c", value: jobForm.experienceDetails.skills },
    ],
  });
  console.log(rest_data);
  

  const fullUrl = `${apiUrl}?method=${method}&input_type=${input_type}&response_type=${response_type}&rest_data=${encodeURIComponent(
    rest_data
  )}`;

  try {
    const response = await axios.post(fullUrl);
    console.log("API Response:", response.data);
  } catch (error) {
    console.error("Error making API call:", error);
  }
};
  

  const renderStepContent = (step) => {
    switch (step) {
      case 1:
        return <CategoryStep />;
      case 2:
        return <Step1 />;
      case 3:
        return <Step2 />;
      case 4:
        return <Step3 />;
      case 5:
        return <ReferralStep />;
      // Add more cases for additional steps
      
    }
  };
 


  return (
    <>
      <DashboardNavbar />
      <Container maxWidth="xl" className='my-6'>
        <div className='text-center max-md:block hidden  pb-2 font-bold '>Job Application</div>
        <Stepper alternativeLabel activeStep={step - 1}  orientation="horizontal">
          <Step>
            <StepLabel ><span className='text-[14px] font-bold'>1</span> <span className='max-md:hidden'>Category details</span></StepLabel>
          </Step>
          <Step>
            <StepLabel ><span className='text-[14px] font-bold'>2</span> <span className='max-md:hidden'>Personal Details</span> </StepLabel>
          </Step>
          <Step>
            <StepLabel ><span className='text-[14px] font-bold'>3</span> <span className='max-md:hidden'>Educational Details</span></StepLabel>
          </Step>
          <Step>
            <StepLabel ><span className='text-[14px] font-bold'>4</span> <span className='max-md:hidden'>Experience Details</span></StepLabel>
          </Step>
          <Step>
            <StepLabel ><span className='text-[14px] font-bold'>5</span> <span className='max-md:hidden'>Referral details</span></StepLabel>
          </Step>
        </Stepper>
        {renderStepContent(step)}
        <div className="flex justify-end mt-4">
        {step > 1 && (
          <button className="btn btn-secondary" onClick={handlePrevStep}>
            Back
          </button>
        )}
        {step < 4 ? (
          <button className="btn btn-primary ml-2" onClick={handleNextStep}>
            Next
          </button>
        ) : (
          <button className="btn btn-success ml-2" onClick={handleSubmit}>
            Submit
          </button>
        )}
        
      </div>
      </Container>
    </>
  );
};

export default MultiForm;
